var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { ViewSizes } from '../types';
var ViewExtraLarge = /** @class */ (function (_super) {
    __extends(ViewExtraLarge, _super);
    function ViewExtraLarge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewExtraLarge.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.props.children || null);
    };
    Object.defineProperty(ViewExtraLarge, "viewSize", {
        get: function () {
            return ViewSizes.EXTRA_LARGE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewExtraLarge, "displayName", {
        get: function () {
            return 'viewportView-extra_large';
        },
        enumerable: false,
        configurable: true
    });
    return ViewExtraLarge;
}(React.Component));
export { ViewExtraLarge };
//# sourceMappingURL=view-extra-large.js.map